// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsRenterGuarantorInvitationsWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  CappsRenterGuarantorInvitationsWebApiHandler_getGuarantorInvite,
  CappsRenterGuarantorInvitationsWebApiHandler_getGuarantorInvite_Path,
  CappsRenterGuarantorInvitationsWebApiHandler_inviteGuarantor,
  CappsRenterGuarantorInvitationsWebApiHandler_removeGuarantor,
} from '@zg-rentals/ts-capps-client';

import type {
  GetGuarantorInviteWebApiResponseDto,
  InviteGuarantorWebApiRequestDto,
  InviteGuarantorWebApiResponseDto,
  RemoveGuarantorWebApiRequestDto,
} from '@zg-rentals/ts-capps-client';

interface GetGuarantorInviteParams {
  applicationId: string;
}

export type CappsRenterGuarantorInvitationsWebApiHandler_getGuarantorInvite_Options = UseQueryOptions<
  GetGuarantorInviteWebApiResponseDto,
  unknown,
  GetGuarantorInviteWebApiResponseDto,
  readonly [string, GetGuarantorInviteParams]
>;

const CappsRenterGuarantorInvitationsWebApiHandler_getGuarantorInvite_GetKey = (getParams: GetGuarantorInviteParams) =>
  [CappsRenterGuarantorInvitationsWebApiHandler_getGuarantorInvite_Path, getParams] as const;

export const CappsRenterGuarantorInvitationsWebApiHandler_getGuarantorInvite_queryOptions = (
  getParams: GetGuarantorInviteParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsRenterGuarantorInvitationsWebApiHandler_getGuarantorInvite_GetKey(getParams),
    queryFn: () => CappsRenterGuarantorInvitationsWebApiHandler_getGuarantorInvite(getParams, httpClient),
  }) as const satisfies QueryOptions;

export const useCappsRenterGuarantorInvitationsWebApiHandler_getGuarantorInvite = (
  getParams: GetGuarantorInviteParams,
  {
    httpClient,
    ...options
  }: Omit<CappsRenterGuarantorInvitationsWebApiHandler_getGuarantorInvite_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...CappsRenterGuarantorInvitationsWebApiHandler_getGuarantorInvite_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useCappsRenterGuarantorInvitationsWebApiHandler_getGuarantorInvite.getKey =
  CappsRenterGuarantorInvitationsWebApiHandler_getGuarantorInvite_GetKey;

export interface CappsRenterGuarantorInvitationsWebApiHandler_inviteGuarantor_Args {
  postData: InviteGuarantorWebApiRequestDto;
}

export type CappsRenterGuarantorInvitationsWebApiHandler_inviteGuarantor_Options = UseMutationOptions<
  InviteGuarantorWebApiResponseDto,
  unknown,
  CappsRenterGuarantorInvitationsWebApiHandler_inviteGuarantor_Args
>;

export const useCappsRenterGuarantorInvitationsWebApiHandler_inviteGuarantor = ({
  httpClient,
  ...options
}: Omit<CappsRenterGuarantorInvitationsWebApiHandler_inviteGuarantor_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsRenterGuarantorInvitationsWebApiHandler_inviteGuarantor_Args) =>
      CappsRenterGuarantorInvitationsWebApiHandler_inviteGuarantor(args.postData, httpClient),
  });
};

export interface CappsRenterGuarantorInvitationsWebApiHandler_removeGuarantor_Args {
  postData: RemoveGuarantorWebApiRequestDto;
}

export type CappsRenterGuarantorInvitationsWebApiHandler_removeGuarantor_Options = UseMutationOptions<
  void,
  unknown,
  CappsRenterGuarantorInvitationsWebApiHandler_removeGuarantor_Args
>;

export const useCappsRenterGuarantorInvitationsWebApiHandler_removeGuarantor = ({
  httpClient,
  ...options
}: Omit<CappsRenterGuarantorInvitationsWebApiHandler_removeGuarantor_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsRenterGuarantorInvitationsWebApiHandler_removeGuarantor_Args) =>
      CappsRenterGuarantorInvitationsWebApiHandler_removeGuarantor(args.postData, httpClient),
  });
};
